import ThemeOptions from "./ThemeOptions";

const reducers = {
  ThemeOptions,
};

export default reducers;
